import { NewsletterContentModule } from '@silvertours/common-landingpages-view';
import { useTranslations } from 'next-intl';
import { NewsletterRegistrationLegacy } from '@silvertours/front-features';

export const NewsletterModule = ({
  badge: { text: badgeText } = { text: '' },
  heading: { text: title } = { text: '' },
  cashbackBadgeText,
  cashbackTooltipText,
  image,
  features: usps = [],
  isPrimaryHeading,
}: NewsletterContentModule & { isPrimaryHeading?: boolean }) => {
  const t = useTranslations(
    'features.newsletterRegistrationLegacy.newsletterRegistration',
  );

  const displayUsps = usps.length
    ? usps
    : [t('usp.first'), t('usp.second'), t('usp.third')];

  return (
    <div id="newsletter">
      <NewsletterRegistrationLegacy.NewsletterRegistration
        type="index"
        badgeText={badgeText}
        heading={title}
        cashbackBadgeText={cashbackBadgeText}
        cashbackTooltipText={cashbackTooltipText}
        image={image}
        usps={displayUsps}
        isPrimaryHeading={isPrimaryHeading}
      />
    </div>
  );
};
